import script from "./DashboardRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardRoute.vue?vue&type=script&setup=true&lang=js"

import "./DashboardRoute.vue?vue&type=style&index=0&id=44688b69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44688b69"]])

export default __exports__